import { getEndpointResource, postJSONEndpointResource } from 'hellospa/common/api/endpoints';
import { trackHeapCustomEvent } from 'common/utils/heap';

type BEStructure = {
  filename: string;
  title: string;
  roles: { [key:string]: string };
  message: string;
}

export type SignerToRole = {
  position: string;
  signer: string;
  role: string;
}

export type TemplateData = {
  filename: string;
  title: string;
  signers: Array<SignerToRole>;
  message: string;
}

export default function docToTemplateActions() {


  async function getDocToTemplateData(docId: string) {
    try {
      const result = await getEndpointResource(`/template/prepareDocumentForTemplate/?guid=${docId}`);

      trackHeapCustomEvent('docToTemplateModalLaunched');
      if (result.data) {
        const data: BEStructure = result.data;
        const signers = Object.keys(data.roles).map((signerPos) => (
          {
            position: signerPos,
            signer: data.roles[signerPos],
            role: '',
          }
        ));
        return {
          filename: data.filename,
          title: data.title,
          signers,
          message: data.message,
        };
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  async function convertDocToTemplate(docId: string, data: TemplateData, edit: boolean = false) {
    const roles: { [key:string]: string } = {};
    data.signers.forEach((signer) => {
      roles[signer.position] = signer.role;
    });

    try {
      const result = await postJSONEndpointResource('template/createFromDocument', {
        body: JSON.stringify({
          guid: docId,
          options: {
            title: data.title,
            message: data.message,
            roles,
            edit,
          },
        }),
      });
      if (result.success && result.data.redirect_url) {
        trackHeapCustomEvent('docToTemplateModalSuccessfulSubmit', {
          templateGuid: result.data.template_guid,
        });
        return result.data;
      }
      return result.error;
    } catch (e) {
      return e;
    }
  }

  async function templateCreateModalDoNotShowToggle(shouldShow: boolean): Promise<boolean> {
    const result = await postJSONEndpointResource('org/updateDoNotShow', {
      body: JSON.stringify({
        templateCreateModalDoNotShow: { value: shouldShow },
      }),
    });
    return result.success;
  }

  return {
    convertDocToTemplate,
    getDocToTemplateData,
    templateCreateModalDoNotShowToggle,
  };
}
